import type { Component } from "../../types";
import { useResponsiveStore } from "./responsive-store";
import {
  CollaborationVersioningUtils,
} from "./versioning-integration";
import type { ComponentSliceState } from "./component-slice-types";
import { MAX_HISTORY_ENTRIES } from "./history-slice";

export function limitHistory(history: Component[][]): Component[][] {
  return history.length > MAX_HISTORY_ENTRIES
    ? history.slice(-MAX_HISTORY_ENTRIES)
    : history;
}

export function syncCurrentPageState(state: ComponentSliceState): void {
  if (!state.currentPageId) {
    return;
  }

  state.pageComponents.set(state.currentPageId, [...state.components]);
  state.pageHistoryMap.set(state.currentPageId, state.history);
}

export function pushComponentSnapshot(state: ComponentSliceState): void {
  if (state._undoBatchActive) {
    syncCurrentPageState(state);
    return;
  }

  state.history.past = limitHistory([
    ...state.history.past,
    [...state.history.present],
  ]);
  state.history.present = [...state.components];
  state.history.future = [];

  syncCurrentPageState(state);
}

export function markCollaborationUpdateIfNeeded(): void {
  if (CollaborationVersioningUtils.shouldSkipCollaborationUpdate()) {
    CollaborationVersioningUtils.markAsCollaborationUpdate();
  }
}

export function notifyResponsiveComponentAdded(component: Component): void {
  try {
    useResponsiveStore.getState().onComponentAdded(component);
  } catch {
    // Silent failure for responsive store integration.
  }
}

export function notifyResponsiveComponentRemoved(componentId: string): void {
  try {
    useResponsiveStore.getState().onComponentRemoved(componentId);
  } catch {
    // Silent failure for responsive store integration.
  }
}
